import React from 'react';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { MarketingCardsUi } from './ui';
import { useContracts } from '../contracts';
import { MarketingCardLoadingPlaceholder } from '@cp-shared-15/frontend-ui';
import { areContractsOneBrand, getMostRecentContractWithBrand } from 'utils';
import { useProductRouting } from './useProductRouting';
import { useDealerDetails } from '../contracts/dealer-details/useDealerDetails';
import { useTranslation } from 'react-i18next';
import { MarketingCards as MarketingCardsType } from 'cpie-common';

const MarketingCardsWithHandlers = withLoadingAndNoConnectionHandler(MarketingCardsUi);

export const MarketingCards: React.FC = () => {
    const { t: cms } = useTranslation('marketing-cards');
    const marketingCards: MarketingCardsType = {
        onlineServicePlan: cms('onlineServicePlan', { returnObjects: true }),
        allianzMotorInsurance: cms('allianzMotorInsurance', { returnObjects: true }),
    };
    const { data: contracts, isLoading: contractsIsLoading } = useContracts();
    const mostRecentContract = getMostRecentContractWithBrand(contracts);
    let unbrandedOSPCard = false;
    const activeContracts = contracts?.filter(contract => contract.isActive);
    const oneBrandContracts = areContractsOneBrand(activeContracts);
    if (!oneBrandContracts) {
        unbrandedOSPCard = true;
    }

    const { data: dealerDetails, isLoading: dealerDetailsIsLoading } = useDealerDetails(
        mostRecentContract?.contractNumber || '',
    );

    const { data: productRouting, isLoading: productRoutingIsLoading } = useProductRouting(mostRecentContract);

    return (
        <MarketingCardsWithHandlers
            isLoading={contractsIsLoading || productRoutingIsLoading || dealerDetailsIsLoading}
            marketingCards={marketingCards}
            hasError={false}
            dealerDetails={dealerDetails}
            onlineServicePlanUrl={unbrandedOSPCard ? 'https://www.vwfs.ie/service-plans/vwfs' : productRouting?.url}
            mostRecentContractBrand={mostRecentContract?.brand}
            unbrandedOSPCard={unbrandedOSPCard}
            loadingPlacehloder={<MarketingCardLoadingPlaceholder />}
        />
    );
};
